import React, { useState, useEffect } from "react";
import { Button, Tooltip } from "@mui/material";
import { useSnackbar } from "notistack";
import { useAdminContext } from "../../Hooks/AdminContext";
import StatusChip from "../../theme/chip";
import { useLocation } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CustomModal from "../../components/CustomModel";
import CustomTable from "../../components/customTable/CustomTable";
import FormInput from "../../components/GeneralComponents/FormInput";
import { formatNumber, show_proper_words } from "../../utils/constant";
import SingleSelectAutocomplete from "../../components/AutoComplete/AutoComplete";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import {
  _List_Affiliate_Payout_For_Admin,
  _Update_Status_Affiliate_Payout,
} from "../../DAL/Listing/Affilate";
import moment from "moment";
import { Scree_Base_List } from "../../DAL/Listing/AgencyAddAcount";
import { max } from "lodash";

const AffiliatePayoutRequest = ({ profile }) => {
  const { setnavbarTitle, socket } = useAdminContext();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [rowDataID, setRowDataID] = useState("");
  const [rowData, setRowData] = useState({});
  const [employee, setEmployee] = useState(null);
  const [modelState, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const [employeeArray, setEmployeeArray] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isCancel, setIsCancel] = useState(false);
  const [userList, setUserList] = useState([]);
  const [Data, setData] = useState({
    address: "",
    amount: "",
  });

  const handleCloseModel = () => {
    setRowData(null);
    setRowDataID(null);
    setEmployee(null);
    setOpenModal(false);
    setIsCancel(false);
    setData({
      address: "",
      amount: "",
    });
  };

  const handleChangeInputs = (e) => {
    setData({ ...Data, [e.target.name]: e.target.value });
  };

  const handleClickEdit = (row) => {
    setRowData(row);
    setRowDataID(row._id);
    setOpenModal(true);
  };

  // This function handles page changes for pagination.
  // It updates the page state to the new page number and adjusts the page count accordingly.
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  // This function handles changes in the number of rows per page for pagination.
  // It updates the rowsPerPage state to the new value and resets the page state to 0.
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // This function handles the page change for pagination.
  // If the new page is less than or equal to 0, it resets the page to 0 and sets the page count to 1.
  // Otherwise, it updates the page state to the new page and adjusts the page count accordingly.
  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  // This function retrieves the list of affiliate payout requests for the admin dashboard.
  // 1. It sets the loading state to true while the request is being processed.
  // 2. It makes an API call to fetch the affiliate payout list using the `_List_Affiliate_Payout_For_Admin` function,
  //    passing the page and rowsPerPage for pagination.
  // 3. If the API call is successful (response.code === 200), it updates the user list with the received `affiliate_payout_list`,
  //    and also sets the total count and total pages for pagination.
  // 4. If the API call fails, it shows an error message using `enqueueSnackbar` and sets the loading state to false.
  const GetAffiliatesRequestList = async () => {
    setLoading(true);
    const response = await _List_Affiliate_Payout_For_Admin(
      {},
      page,
      rowsPerPage
    );
    if (response.code === 200) {
      const { affiliate_payout_list = [], total_count, total_pages } = response;
      setUserList(affiliate_payout_list);
      setTotalCount(total_count);
      setTotalPages(total_pages);
      setLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
  };

  // This array defines the columns and rendering behavior for the user data table.
  // Each object in the array corresponds to a column, including its label, id, and how to render the data.
  const User_Table_Head = [
    {
      id: "action",
      label: "Action",
      renderData: (row) => (
        <Tooltip title="View Detail" placement="top">
          <RemoveRedEyeIcon
            style={{
              fill: "#fff",
              marginRight: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              handleClickEdit(row);
            }}
          />
        </Tooltip>
      ),
    },
    {
      id: "number",
      label: "#",
      type: "number",
    },
    {
      id: "user_info",
      label: "User",
      renderData: (row) => (
        <div
          className="pointer"
          onClick={() => {
            handleClickEdit(row);
          }}
        >
          <div>{`${row.user_info?.first_name || "_ _"} ${
            row.user_info?.last_name || ""
          }`}</div>
          <div className="text-muted" style={{ fontSize: "0.9em" }}>
            {row.user_info?.email || "_ _"}
          </div>
        </div>
      ),
    },
    {
      id: "",
      label: "Requested Withdrawal Amount",
      renderData: (row) => (
        <span>
          $
          {row?.withdraw_amount
            ? Number.isInteger(row.withdraw_amount)
              ? row.withdraw_amount
              : row.withdraw_amount.toFixed(2)
            : "0"}
        </span>
      ),
    },
    {
      id: "",
      label: "Tax Amount",
      renderData: (row) => (
        <span>
          $
          {row?.tax_amount
            ? Number.isInteger(row.tax_amount)
              ? row.tax_amount
              : row.tax_amount.toFixed(2)
            : "0"}
        </span>
      ),
    },
    {
      id: "",
      label: "Amount Sent",
      renderData: (row) => (
        <span>
          $
          {row?.amount_after_tax
            ? Number.isInteger(row.amount_after_tax)
              ? row.amount_after_tax
              : row.amount_after_tax.toFixed(2)
            : "0"}
        </span>
      ),
    },
    {
      id: "createdAt",
      label: "Date",
      renderData: (row) => (
        <span>{moment(row?.createdAt).format("DD MMM YY hh:mm A")}</span>
      ),
    },
    {
      id: "status",
      label: "Status",
      renderData: (row) => (
        <StatusChip status={row.status} type="activeInactive" />
      ),
    },
  ];

  /**
   * Handles the approval or rejection of a withdrawal request for an affiliate.
   *
   * This function is triggered when the "Approve" or "Reject" button is clicked for a withdrawal request.
   * It prepares the necessary data and calls an API to update the withdrawal request status (either approved or rejected).
   *
   * The function performs the following actions:
   * 1. Prevents the default form submission behavior.
   * 2. Prepares the form data based on the current employee, request data, and cancellation status.
   * 3. If the request is being rejected, it adds the status as 'rejected', includes the message, and removes tax and amount calculations.
   * 4. If the request is approved, it adds the status as 'approved', calculates the tax amount and the amount after tax.
   * 5. Sets the button loading state to true while waiting for the response from the server.
   * 6. Sends the form data to the backend API using `_Update_Status_Affiliate_Payout` to update the withdrawal status.
   * 7. If the request is successful (response code 200), it:
   *    - Emits a socket event to notify the front-end of the status update.
   *    - Resets the form data (clears address and employee).
   *    - Refreshes the affiliate request list.
   *    - Closes the modal and stops the loading state.
   * 8. If the request fails, it stops the loading state and displays an error message using the snackbar.
   */
  const handleApproveWithDrawReq = async (e) => {
    e.preventDefault();
    const formData = {
      employee_id: employee.id,
      message: Data?.address || "",
      status: isCancel ? "rejected" : "approved",
      tax_amount: Number(Data?.amount) || "",
      amount_after_tax:
        Number(rowData.withdraw_amount) - Number(Data?.amount) || "",
    };

    if (!isCancel) {
      delete formData.message;
    }
    if (isCancel) {
      delete formData.tax_amount;
      delete formData.amount_after_tax;
    }
    setLoadingButton(true);
    const response = await _Update_Status_Affiliate_Payout(formData, rowDataID);
    if (response.code === 200) {
      socket.emit("affiliate_payout_event", {
        notification: response.notification,
      });
      setData({
        address: "",
      });
      setEmployee(null);
      GetAffiliatesRequestList();
      handleCloseModel();
      setLoadingButton(false);
    } else {
      setLoadingButton(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  /**
   * Fetches and formats employee details based on a search value.
   *
   * Sends a search request for employees, formats the response data, and updates the `employeeArray` state.
   * - Prepares and sends search data to the server.
   * - If successful, formats the employee details (id, name, email).
   * - Updates the state with the formatted data.
   */

  const handleGetDetailUser = async (value) => {
    const FormData = {
      type: "employee",
      search: value,
    };
    const response = await Scree_Base_List(FormData);
    if (response.code === 200) {
      const FormatData = response?.list?.map((value) => {
        return {
          id: value.user_id,
          name: show_proper_words(value.first_name + " " + value.last_name),
          email: value.email,
        };
      });
      setEmployeeArray(FormatData);
    }
  };

  useEffect(() => {
    GetAffiliatesRequestList();
    setnavbarTitle("Affiliate Payout Request");
  }, [rowsPerPage, page, location.state?.refresh]);

  useEffect(() => {
    handleGetDetailUser();
  }, []);

  if (loading) {
    return <CustomCircularProgress />;
  }
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 mb-3"></div>
        <CustomTable
          data={userList}
          TABLE_HEAD={User_Table_Head}
          MENU_OPTIONS={[]}
          custom_pagination={{
            total_count: totalCount,
            rows_per_page: rowsPerPage,
            page: page,
            handleChangePage: handleChangePage,
            onRowsPerPageChange: handleChangeRowsPerPage,
          }}
          pageCount={pageCount}
          totalPages={totalPages}
          pagePagination={true}
          handleChangePages={handleChangePages}
          is_hide={true}
        />
      </div>
      <CustomModal
        crossButton={true}
        CustomSpacing={true}
        open={modelState}
        handleClose={handleCloseModel}
        component={
          <form onSubmit={handleApproveWithDrawReq}>
            {isCancel ? (
              <div className="mt-4">
                <FormInput
                  label="Reject Message"
                  name="address"
                  type="text"
                  multline={true}
                  value={Data.address}
                  onChange={(e) =>
                    setData({ ...Data, address: e.target.value })
                  }
                />
              </div>
            ) : (
              <>
                <h5>Payout Details</h5>
                <div className="d-flex justify-content-between align-center mt-2">
                  <p className="mb-0">Withdraw Amount</p>
                  <p className="mb-0 text-muted">
                    ${rowData?.withdraw_amount || "0"}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-center mt-2">
                  <p className="mb-0">Date</p>
                  <p className="mb-0 text-muted">
                    {moment(rowData?.createdAt).format("DD MMM YY hh:mm A")}
                  </p>
                </div>
                <div className="d-flex justify-content-between align-center mt-2">
                  <p className="mb-0">Available Balance</p>
                  <p className="mb-0 text-muted">
                    ${formatNumber(rowData?.available_balance) || "0"}
                  </p>
                </div>

                <div className="my-3">
                  <SingleSelectAutocomplete
                    inputLabel="Approve or Reject By"
                    selectedOption={employee}
                    setSelectedOption={setEmployee}
                    optionsList={employeeArray}
                    required={true}
                    name="name"
                    size="medium"
                  />
                </div>

                {(rowData?.status === "rejected" ||
                  rowData?.status === "pending") && (
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-6">
                      <FormInput
                        InputProps={{
                          readOnly: true,
                        }}
                        type={"text"}
                        label="Withdraw Requested Amount"
                        name="amount"
                        value={"$" + rowData?.withdraw_amount}
                      ></FormInput>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6">
                      <FormInput
                        type={"number"}
                        inputProps={{
                          min: 0,
                          max: rowData?.withdraw_amount,
                        }}
                        label="Fee Deducted $"
                        name="amount"
                        value={Data?.amount}
                        onChange={handleChangeInputs}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-lg-6">
                      <FormInput
                        InputProps={{
                          readOnly: true,
                        }}
                        type={"text"}
                        label="Amount after Fee Deduction"
                        name="amount"
                        value={
                          Number(rowData?.withdraw_amount) -
                          Number(Data?.amount)
                        }
                      />
                    </div>
                  </div>
                )}
              </>
            )}
            <div className="col-12 text-end mt-3 mb-2">
              {!isCancel ? (
                <>
                  {rowData?.status !== "rejected" && (
                    <Tooltip
                      title={
                        !employee ? "Please select all the required fields" : ""
                      }
                    >
                      <span>
                        <Button
                          variant="contained"
                          disabled={!employee || loadingButton}
                          onClick={() => {
                            setIsCancel(true);
                          }}
                        >
                          Reject
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                </>
              ) : (
                <Button
                  variant="contained"
                  onClick={() => {
                    setIsCancel(false);
                  }}
                >
                  Back
                </Button>
              )}
              {(rowData?.status !== "approved" || isCancel) && (
                <Tooltip
                  title={
                    !employee
                      ? "Please select all the required fields"
                      : Number(Data?.amount) > Number(rowData?.withdraw_amount)
                      ? "Amount is greater than withdraw amount"
                      : ""
                  }
                >
                  <span>
                    <Button
                      variant="contained"
                      className="ms-3"
                      disabled={
                        !employee ||
                        loadingButton ||
                        Number(Data?.amount) > Number(rowData?.withdraw_amount)
                      }
                      type="submit"
                    >
                      {loadingButton
                        ? "Please Wait..."
                        : isCancel
                        ? "Reject"
                        : "Approve"}
                    </Button>
                  </span>
                </Tooltip>
              )}
            </div>
          </form>
        }
      />
    </div>
  );
};

export default AffiliatePayoutRequest;
